/* Hanzo landing page: countdown, testimonial carousel, add-to-cart */
(function () {
  'use strict';

  /* ---- evergreen countdown ------------------------------------
     Per-visitor deadline stored in localStorage; restarts when it
     runs out, so the offer always looks live. data-hours sets the
     window length. */
  if (!customElements.get('hanzo-countdown')) {
    customElements.define(
      'hanzo-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.hours = parseFloat(this.dataset.hours) || 6;
          this.key = 'hz-count-' + (this.dataset.key || 'default');
          this.nums = {
            d: this.querySelector('[data-unit="d"]'),
            h: this.querySelector('[data-unit="h"]'),
            m: this.querySelector('[data-unit="m"]'),
            s: this.querySelector('[data-unit="s"]'),
          };
          this.tick = this.tick.bind(this);
          this.timer = setInterval(this.tick, 1000);
          this.tick();
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        deadline() {
          let end = 0;
          try {
            end = parseInt(localStorage.getItem(this.key), 10) || 0;
          } catch (e) { /* private mode */ }
          const now = Date.now();
          if (end <= now) {
            end = now + this.hours * 3600 * 1000;
            try {
              localStorage.setItem(this.key, String(end));
            } catch (e) { /* ignore */ }
          }
          return end;
        }
        tick() {
          let left = Math.max(0, this.deadline() - Date.now());
          const day = Math.floor(left / 86400000);
          left -= day * 86400000;
          const hr = Math.floor(left / 3600000);
          left -= hr * 3600000;
          const min = Math.floor(left / 60000);
          const sec = Math.floor((left - min * 60000) / 1000);
          const pad = (n) => String(n).padStart(2, '0');
          if (this.nums.d) this.nums.d.textContent = pad(day);
          if (this.nums.h) this.nums.h.textContent = pad(hr);
          if (this.nums.m) this.nums.m.textContent = pad(min);
          if (this.nums.s) this.nums.s.textContent = pad(sec);
        }
      }
    );
  }

  /* ---- testimonial carousel ----------------------------------- */
  if (!customElements.get('hanzo-carousel')) {
    customElements.define(
      'hanzo-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.hz-car-track');
          this.counter = this.querySelector('.hz-car-count');
          if (!this.track) return;
          this.querySelectorAll('[data-dir]').forEach((btn) =>
            btn.addEventListener('click', () => this.move(parseInt(btn.dataset.dir, 10)))
          );
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', () => this.update(), { passive: true });
          this.update();
        }
        pageWidth() {
          return this.track.clientWidth;
        }
        pages() {
          return Math.max(1, Math.round(this.track.scrollWidth / this.pageWidth()));
        }
        page() {
          return Math.min(this.pages(), Math.round(this.track.scrollLeft / this.pageWidth()) + 1);
        }
        move(dir) {
          this.track.scrollBy({ left: dir * this.pageWidth(), behavior: 'smooth' });
        }
        update() {
          if (this.counter) this.counter.textContent = this.page() + ' / ' + this.pages();
        }
      }
    );
  }

  /* ---- add to cart --------------------------------------------
     Same flow the theme's buy-buttons snippet uses: POST to
     /cart/add.js, then refresh + open the cart drawer. Falls back
     to the /cart page when no drawer exists. */
  let busy = false;
  function bindForms() {
    document.querySelectorAll('form.hz-cta-form[data-hz-atc]').forEach((form) => {
      if (form.dataset.hzBound) return;
      form.dataset.hzBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        busy = true;
        const btn = form.querySelector('button[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');

        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then((r) => {
            if (!r.ok) return r.json().then((err) => { throw new Error(err.description || 'error'); });
            return r.json();
          })
          .then(() => fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } }))
          .then((res) => res.json())
          .then((state) => {
            const currentDrawer = document.querySelector('cart-drawer');
            if (state['cart-drawer'] && currentDrawer) {
              const temp = document.createElement('div');
              temp.innerHTML = state['cart-drawer'];
              const newDrawer = temp.querySelector('cart-drawer');
              if (newDrawer) {
                currentDrawer.replaceWith(newDrawer);
                if (typeof newDrawer.open === 'function') {
                  newDrawer.open();
                } else {
                  newDrawer.setAttribute('open', 'true');
                  newDrawer.classList.add('is-open', 'active', 'animate');
                }
              }
            } else if (!currentDrawer) {
              window.location.href = '/cart';
              return;
            }
            if (state['cart-icon-bubble']) {
              const bubble = document.querySelector('#cart-icon-bubble');
              if (bubble) bubble.innerHTML = state['cart-icon-bubble'];
            }
          })
          .catch(() => {
            window.location.href = '/cart';
          })
          .finally(() => {
            if (btn) btn.removeAttribute('aria-busy');
            setTimeout(() => { busy = false; }, 800);
          });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForms);
  } else {
    bindForms();
  }
  document.addEventListener('shopify:section:load', bindForms);
})();
